import { defineComponent as _defineComponent } from 'vue'
import { useCompanyFeatureComposable } from '@/composables/useCompanyFeatures';
import { computed } from 'vue';
import PasswordSettingPageDemo from '@/views/pages/passwordSetting/PasswordSettingPageDemo.vue';
import PasswordSettingPage from '@/views/pages/passwordSetting/PasswordSettingPage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConditionalPasswordSettingPage',
  setup(__props) {

const { isFeatureActive, COMPANY_FEATURES } = useCompanyFeatureComposable();

const isPasswordSettingActive = computed(() =>
  isFeatureActive(COMPANY_FEATURES.MANAGE_PASSWORD_SETTING)
);

return { __sfc: true,isFeatureActive, COMPANY_FEATURES, isPasswordSettingActive, PasswordSettingPageDemo, PasswordSettingPage }
}

})